import { Position, Sport } from '../types';

// Define the position structure for each sport
export const SPORT_POSITIONS: Record<Sport, Record<string, Position[]>> = {
  Football: {
    Offense: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Y/Tight End', color: '' },
      { key: 'SL', name: 'SL', fullName: 'Slot Receiver', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ],
    Defense: [
      { key: 'EDGE', name: 'EDGE', fullName: 'Edge Rusher', color: '' },
      { key: 'DE', name: 'DE', fullName: 'Defensive End', color: '' }, // Keep for backward compatibility
      { key: 'DT', name: 'DT', fullName: 'Defensive Tackle', color: '' },
      { key: 'NT', name: 'NT', fullName: 'Nose Tackle', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'SLB', name: 'SLB', fullName: 'Strongside Linebacker', color: '' },
      { key: 'CB', name: 'CB', fullName: 'Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety', color: '' },
      { key: 'NB', name: 'NB', fullName: 'Nickelback', color: '' }
    ],
    'Special Teams': [
      { key: 'K', name: 'K', fullName: 'Kicker', color: '' },
      { key: 'P', name: 'P', fullName: 'Punter', color: '' },
      { key: 'LS', name: 'LS', fullName: 'Long Snapper', color: '' },
      { key: 'KR', name: 'KR', fullName: 'Kick Returner', color: '' },
      { key: 'PR', name: 'PR', fullName: 'Punt Returner', color: '' },
      { key: 'G', name: 'G', fullName: 'Gunner', color: '' }
    ]
  },
  FlagFootball: {
    Offense: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'WR1', name: 'WR1', fullName: 'Wide Receiver 1', color: '' },
      { key: 'WR2', name: 'WR2', fullName: 'Wide Receiver 2', color: '' },
      { key: 'SL', name: 'SL', fullName: 'Slot Receiver', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' }
    ],
    Defense: [
      { key: 'R', name: 'R', fullName: 'Rusher', color: '' },
      { key: 'LB', name: 'LB', fullName: 'Linebacker', color: '' },
      { key: 'CB1', name: 'CB1', fullName: 'Cornerback 1', color: '' },
      { key: 'CB2', name: 'CB2', fullName: 'Cornerback 2', color: '' },
      { key: 'S', name: 'S', fullName: 'Safety', color: '' }
    ],
    'Special Teams': []
  },
  Basketball: {
    Offense: [
      { key: 'PG', name: 'PG', fullName: 'Point Guard', color: '' },
      { key: 'SG', name: 'SG', fullName: 'Shooting Guard', color: '' },
      { key: 'SF', name: 'SF', fullName: 'Small Forward', color: '' },
      { key: 'PF', name: 'PF', fullName: 'Power Forward', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' }
    ],
    Defense: [
      { key: 'PG', name: 'PG', fullName: 'Point Guard', color: '' },
      { key: 'SG', name: 'SG', fullName: 'Shooting Guard', color: '' },
      { key: 'SF', name: 'SF', fullName: 'Small Forward', color: '' },
      { key: 'PF', name: 'PF', fullName: 'Power Forward', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' }
    ]
  },
  Soccer: {
    Offense: [
      { key: 'ST', name: 'ST', fullName: 'Striker', color: '' },
      { key: 'CF', name: 'CF', fullName: 'Center Forward', color: '' },
      { key: 'LW', name: 'LW', fullName: 'Left Wing', color: '' },
      { key: 'RW', name: 'RW', fullName: 'Right Wing', color: '' },
      { key: 'CAM', name: 'CAM', fullName: 'Central Attacking Midfielder', color: '' }
    ],
    Defense: [
      { key: 'GK', name: 'GK', fullName: 'Goalkeeper', color: '' },
      { key: 'LB', name: 'LB', fullName: 'Left Back', color: '' },
      { key: 'CB', name: 'CB', fullName: 'Center Back', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Right Back', color: '' },
      { key: 'CDM', name: 'CDM', fullName: 'Central Defensive Midfielder', color: '' }
    ]
  },
  Baseball: {
    Offense: [
      { key: '1', name: '1', fullName: 'Leadoff', color: '' },
      { key: '2', name: '2', fullName: '2nd Batter', color: '' },
      { key: '3', name: '3', fullName: '3rd Batter', color: '' },
      { key: '4', name: '4', fullName: 'Cleanup', color: '' },
      { key: '5', name: '5', fullName: '5th Batter', color: '' },
      { key: '6', name: '6', fullName: '6th Batter', color: '' },
      { key: '7', name: '7', fullName: '7th Batter', color: '' },
      { key: '8', name: '8', fullName: '8th Batter', color: '' },
      { key: '9', name: '9', fullName: '9th Batter', color: '' }
    ],
    Defense: [
      { key: 'P', name: 'P', fullName: 'Pitcher', color: '' },
      { key: 'C', name: 'C', fullName: 'Catcher', color: '' },
      { key: '1B', name: '1B', fullName: 'First Base', color: '' },
      { key: '2B', name: '2B', fullName: 'Second Base', color: '' },
      { key: '3B', name: '3B', fullName: 'Third Base', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Shortstop', color: '' },
      { key: 'LF', name: 'LF', fullName: 'Left Field', color: '' },
      { key: 'CF', name: 'CF', fullName: 'Center Field', color: '' },
      { key: 'RF', name: 'RF', fullName: 'Right Field', color: '' },
      { key: 'DH', name: 'DH', fullName: 'Designated Hitter', color: '' }
    ]
  },
  Softball: {
    Offense: [
      { key: '1', name: '1', fullName: 'Leadoff', color: '' },
      { key: '2', name: '2', fullName: '2nd Batter', color: '' },
      { key: '3', name: '3', fullName: '3rd Batter', color: '' },
      { key: '4', name: '4', fullName: 'Cleanup', color: '' },
      { key: '5', name: '5', fullName: '5th Batter', color: '' },
      { key: '6', name: '6', fullName: '6th Batter', color: '' },
      { key: '7', name: '7', fullName: '7th Batter', color: '' },
      { key: '8', name: '8', fullName: '8th Batter', color: '' },
      { key: '9', name: '9', fullName: '9th Batter', color: '' }
    ],
    Defense: [
      { key: 'P', name: 'P', fullName: 'Pitcher', color: '' },
      { key: 'C', name: 'C', fullName: 'Catcher', color: '' },
      { key: '1B', name: '1B', fullName: 'First Base', color: '' },
      { key: '2B', name: '2B', fullName: 'Second Base', color: '' },
      { key: '3B', name: '3B', fullName: 'Third Base', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Shortstop', color: '' },
      { key: 'LF', name: 'LF', fullName: 'Left Field', color: '' },
      { key: 'CF', name: 'CF', fullName: 'Center Field', color: '' },
      { key: 'RF', name: 'RF', fullName: 'Right Field', color: '' }
    ]
  },
  Volleyball: {
    Offense: [
      { key: 'S', name: 'S', fullName: 'Setter', color: '' },
      { key: 'OH', name: 'OH', fullName: 'Outside Hitter', color: '' },
      { key: 'MB', name: 'MB', fullName: 'Middle Blocker', color: '' },
      { key: 'OP', name: 'OP', fullName: 'Opposite Hitter', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Serving Specialist', color: '' }
    ],
    Defense: [
      { key: 'L', name: 'L', fullName: 'Libero', color: '' },
      { key: 'DS', name: 'DS', fullName: 'Defensive Specialist', color: '' },
      { key: 'MB', name: 'MB', fullName: 'Middle Blocker', color: '' }
    ]
  },
  Hockey: {
    Offense: [
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'LW', name: 'LW', fullName: 'Left Wing', color: '' },
      { key: 'RW', name: 'RW', fullName: 'Right Wing', color: '' }
    ],
    Defense: [
      { key: 'G', name: 'G', fullName: 'Goaltender', color: '' },
      { key: 'LD', name: 'LD', fullName: 'Left Defense', color: '' },
      { key: 'RD', name: 'RD', fullName: 'Right Defense', color: '' }
    ]
  },
  Lacrosse: {
    Offense: [
      { key: 'A', name: 'A', fullName: 'Attack', color: '' },
      { key: 'M', name: 'M', fullName: 'Midfield', color: '' },
      { key: 'F', name: 'F', fullName: 'FOGO', color: '' }
    ],
    Defense: [
      { key: 'G', name: 'G', fullName: 'Goalie', color: '' },
      { key: 'D', name: 'D', fullName: 'Defense', color: '' },
      { key: 'LSM', name: 'LSM', fullName: 'Long-stick Midfield', color: '' }
    ]
  },
  Tennis: {
    Offense: [
      { key: 'S1', name: 'S1', fullName: 'Singles 1', color: '' },
      { key: 'S2', name: 'S2', fullName: 'Singles 2', color: '' },
      { key: 'S3', name: 'S3', fullName: 'Singles 3', color: '' },
      { key: 'S4', name: 'S4', fullName: 'Singles 4', color: '' },
      { key: 'S5', name: 'S5', fullName: 'Singles 5', color: '' },
      { key: 'S6', name: 'S6', fullName: 'Singles 6', color: '' },
      { key: 'D1', name: 'D1', fullName: 'Doubles 1', color: '' },
      { key: 'D2', name: 'D2', fullName: 'Doubles 2', color: '' },
      { key: 'D3', name: 'D3', fullName: 'Doubles 3', color: '' }
    ],
    Defense: [
      { key: 'S1', name: 'S1', fullName: 'Singles 1', color: '' },
      { key: 'S2', name: 'S2', fullName: 'Singles 2', color: '' },
      { key: 'S3', name: 'S3', fullName: 'Singles 3', color: '' },
      { key: 'S4', name: 'S4', fullName: 'Singles 4', color: '' },
      { key: 'S5', name: 'S5', fullName: 'Singles 5', color: '' },
      { key: 'S6', name: 'S6', fullName: 'Singles 6', color: '' },
      { key: 'D1', name: 'D1', fullName: 'Doubles 1', color: '' },
      { key: 'D2', name: 'D2', fullName: 'Doubles 2', color: '' },
      { key: 'D3', name: 'D3', fullName: 'Doubles 3', color: '' }
    ]
  }
};

// Define offensive formations
export const FOOTBALL_OFFENSIVE_FORMATIONS = {
  'Spread': '11v11', // Default spread is already defined
  'Wing-T': '11v11-FB', // Uses fullback
  'I-Form': '11v11-FB', // Uses fullback
  'Pro Style': '11v11-2TE', // Uses 2 tight ends
  'Air Raid': '11v11', // Base with 4 receivers
  'Option': '11v11', 
  'Single Wing': '11v11-FB',
  'West Coast': '11v11',
  'Run and Shoot': '11v11'
};

// Define defensive formations
export const FOOTBALL_DEFENSIVE_FORMATIONS = {
  '4-3': '4-3-Defense',
  '3-4': '3-4-Defense',
  '4-4-3': '4-4-Defense',
  'Nickel': 'Nickel-Defense',
  '46': '46-Defense',
  '5-2': '5-2-Defense',
  'Cover 2': '4-3-Defense', // Base on 4-3
  'Cover 3': '4-3-Defense', // Base on 4-3
  '4-2-5': 'Nickel-Defense', // Similar to nickel
  '3-3-5': '3-4-Defense', // Base on 3-4
  'Tampa 2': '4-3-Defense' // Base on 4-3
};

// Special teams positions
export const SPECIAL_TEAMS_POSITIONS: Record<string, Position[]> = {
  'Kickoff': [
    { key: 'K', name: 'K', fullName: 'Kicker', color: '' },
    { key: 'L1', name: 'L1', fullName: 'Left 1', color: '' },
    { key: 'L2', name: 'L2', fullName: 'Left 2', color: '' },
    { key: 'L3', name: 'L3', fullName: 'Left 3', color: '' },
    { key: 'L4', name: 'L4', fullName: 'Left 4', color: '' },
    { key: 'L5', name: 'L5', fullName: 'Left 5', color: '' },
    { key: 'R1', name: 'R1', fullName: 'Right 1', color: '' },
    { key: 'R2', name: 'R2', fullName: 'Right 2', color: '' },
    { key: 'R3', name: 'R3', fullName: 'Right 3', color: '' },
    { key: 'R4', name: 'R4', fullName: 'Right 4', color: '' },
    { key: 'R5', name: 'R5', fullName: 'Right 5', color: '' }
  ],
  'Kick Return': [
    { key: 'KR1', name: 'KR1', fullName: 'Primary Returner', color: '' },
    { key: 'KR2', name: 'KR2', fullName: 'Secondary Returner', color: '' },
    { key: 'FB', name: 'FB', fullName: 'Fullback', color: '' },
    { key: 'F1', name: 'F1', fullName: 'Front 1', color: '' },
    { key: 'F2', name: 'F2', fullName: 'Front 2', color: '' },
    { key: 'F3', name: 'F3', fullName: 'Front 3', color: '' },
    { key: 'F4', name: 'F4', fullName: 'Front 4', color: '' },
    { key: 'M1', name: 'M1', fullName: 'Middle 1', color: '' },
    { key: 'M2', name: 'M2', fullName: 'Middle 2', color: '' },
    { key: 'M3', name: 'M3', fullName: 'Middle 3', color: '' },
    { key: 'M4', name: 'M4', fullName: 'Middle 4', color: '' }
  ],
  'Punt': [
    { key: 'P', name: 'P', fullName: 'Punter', color: '' },
    { key: 'LS', name: 'LS', fullName: 'Long Snapper', color: '' },
    { key: 'PP', name: 'PP', fullName: 'Personal Protector', color: '' },
    { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
    { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
    { key: 'LW', name: 'LW', fullName: 'Left Wing', color: '' },
    { key: 'RW', name: 'RW', fullName: 'Right Wing', color: '' },
    { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
    { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' },
    { key: 'GLt', name: 'GLt', fullName: 'Gunner Left', color: '' },
    { key: 'GRt', name: 'GRt', fullName: 'Gunner Right', color: '' }
  ],
  'Punt Return': [
    { key: 'PR', name: 'PR', fullName: 'Punt Returner', color: '' },
    { key: 'LOLB', name: 'LOLB', fullName: 'Left Outside LB', color: '' },
    { key: 'LILB', name: 'LILB', fullName: 'Left Inside LB', color: '' },
    { key: 'MLB', name: 'MLB', fullName: 'Middle LB', color: '' },
    { key: 'RILB', name: 'RILB', fullName: 'Right Inside LB', color: '' },
    { key: 'ROLB', name: 'ROLB', fullName: 'Right Outside LB', color: '' },
    { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
    { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
    { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
    { key: 'LS', name: 'LS', fullName: 'Left Safety', color: '' },
    { key: 'RS', name: 'RS', fullName: 'Right Safety', color: '' }
  ],
  'Field Goal': [
    { key: 'K', name: 'K', fullName: 'Kicker', color: '' },
    { key: 'H', name: 'H', fullName: 'Holder', color: '' },
    { key: 'LS', name: 'LS', fullName: 'Long Snapper', color: '' },
    { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
    { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
    { key: 'LE', name: 'LE', fullName: 'Left End', color: '' },
    { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
    { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' },
    { key: 'RE', name: 'RE', fullName: 'Right End', color: '' },
    { key: 'WB1', name: 'WB1', fullName: 'Wing Back 1', color: '' },
    { key: 'WB2', name: 'WB2', fullName: 'Wing Back 2', color: '' }
  ],
  'Default': [
    { key: 'K', name: 'K', fullName: 'Kicker', color: '' },
    { key: 'P', name: 'P', fullName: 'Punter', color: '' },
    { key: 'LS', name: 'LS', fullName: 'Long Snapper', color: '' },
    { key: 'KR', name: 'KR', fullName: 'Kick Returner', color: '' },
    { key: 'PR', name: 'PR', fullName: 'Punt Returner', color: '' },
    { key: 'GL', name: 'GL', fullName: 'Gunner Left', color: '' },
    { key: 'GR', name: 'GR', fullName: 'Gunner Right', color: '' },
    { key: 'PP', name: 'PP', fullName: 'Personal Protector', color: '' },
    { key: 'LW', name: 'LW', fullName: 'Left Wing', color: '' },
    { key: 'RW', name: 'RW', fullName: 'Right Wing', color: '' },
    { key: 'H', name: 'H', fullName: 'Holder', color: '' }
  ]
}; 